<template>
	<b-row class="justify-content-center">
		<b-col md="8" lg="6" xl="3">
			<b-card border-variant="light text-center">
				<b-card-title class="mb-4 mt-5"><b>{{ $t('text_login_title') | toUpperCase }}</b></b-card-title>
				<b-card-sub-title class="mb-4">{{ $t('text_login_subtitle') }}</b-card-sub-title>
				<b-form @submit.prevent="handleLogin" class="margin-bottom-0">
					<b-form-input class="mb-4" size="sm" v-model="username" type="email" :placeholder="$t('text_login_email_placeholder')" required />
					<b-form-input class="mb-2" size="sm" v-model="password" type="password" :placeholder="$t('text_login_password_placeholder')" required />
					<b-row class="mb-3">
						<b-col class="text-center">
						</b-col>
						<b-col class="text-center">
						</b-col>
					</b-row>
					<b-row>
						<b-col />
						<b-col cols="9" class="mb-5">
							<b-button variant="primary" type="submit">{{ $t('text_login') | toUpperCase }}</b-button>
						</b-col>
						<b-col />
					</b-row>
				</b-form>
			</b-card>
		</b-col>
	</b-row>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PageOptions from '../config/PageOptions'

export default {
	beforeRouteLeave (to, from, next) {
		PageOptions.pageWithSidebar = true;
		PageOptions.pageWithHeaderToggles = true;
		PageOptions.pageWithHeaderNavigation = true;
		PageOptions.pageWithCenteredFooter = false;
		next();
	},
	data: () => ({
		username: '',
		password: ''
	}),
	computed: {
		...mapState('auth', ['status'])
	},
	filters: {
		toUpperCase(value) {
			value = value.toString();
			return value.toUpperCase();
		}
	},
	methods: {
		...mapActions('auth', ['login']),
		handleLogin() {
			event.preventDefault();
			const { username, password } = this
			if (username && password) {
				this.login({ username, password })
			}
		}
	},
	created() {
		PageOptions.pageWithSidebar = false;
		PageOptions.pageWithHeaderToggles = false;
		PageOptions.pageWithHeaderNavigation = false;
		PageOptions.pageWithCenteredFooter = true;
	}
}
</script>
